/**
 * Este arquivo contém configurações relacionadas a permissões de usuários específicos
 * 
 * CONTROLE DE ACESSO - PLANOS DE TRATAMENTO:
 * - Atualmente: Permissões definidas por clínica via flags enviadas no login
 * - Futuro: Qualquer clínica poderá usar planos de tratamento com seus próprios pacientes
 * 
 * PARA LIBERAR PARA TODAS AS CLÍNICAS:
 * - Alterar TREATMENT_PLAN_ACCESS_ENABLED_FOR_ALL_CLÍNICAS = true
 * - A flag recebida no login será ignorada
 * - Qualquer usuário autenticado terá acesso
 */

// CONFIGURAÇÃO DE PERMISSÕES - TEMPORÁRIO
// Para liberar para todas as clínicas, altere a flag abaixo para true
export const TREATMENT_PLAN_ACCESS_ENABLED_FOR_ALL_CLINICS = false;

/**
 * Verifica se um usuário tem acesso à funcionalidade de planos de tratamento
 * 
 * LÓGICA ATUAL:
 * - Respeita a flag enviada pelo backend no login (armazenada no AuthService)
 * 
 * LÓGICA FUTURA (quando liberar para todas as clínicas):
 * - Qualquer usuário com clínica associada terá acesso
 * 
 * @param userId ID do usuário a ser verificado
 * @param _userClinicCnpj CNPJ da clínica do usuário (opcional, mantido por compatibilidade)
 * @returns true se o usuário tem acesso, false caso contrário
 */
export function hasTreatmentPlanAccess(userId: string | null | undefined, _userClinicCnpj?: string | null): boolean {
  if (!userId) return false;
  
  // VERIFICAR SE AS PERMISSÕES ESTÃO LIBERADAS PARA TODAS AS CLÍNICAS
  if (TREATMENT_PLAN_ACCESS_ENABLED_FOR_ALL_CLINICS) {
    return true;
  }
  
  try {
    const storedPermission = localStorage.getItem('treatmentPlanPermission');
    if (!storedPermission) {
      return false;
    }
    return atob(storedPermission) === 'true';
  } catch (err) {
    console.warn('Erro ao recuperar permissões de plano de tratamento.', err);
    return false;
  }
} 
